/**
 * Client-side mirror of api/_lib/roles.js, used only to decide what the Roles &
 * Access screen offers. The server enforces the real policy, so if the two ever
 * drift the worst case is a role the screen offers but the server refuses.
 * Keep this in step with api/_lib/roles.js.
 */

export const STAFF_ROLE_MAP: Record<string, string[]> = {
  'System Administrator': ['system_admin', 'provider'],
  'Clinical Director': ['clinical_director', 'provider'],
  'Provider (Clinician)': ['provider'],
  'Administrative Staff': ['administrative_staff'],
  'HR Admin': ['hr_admin'],
};

const GRANTER_ROLES = ['system_admin', 'clinical_director', 'hr_admin'];

const ROLE_RANK: Record<string, number> = {
  system_admin: 3,
  clinical_director: 2,
  hr_admin: 2,
  provider: 1,
  administrative_staff: 1,
};

const highestRank = (roles: string[]) =>
  roles.reduce((max, role) => Math.max(max, ROLE_RANK[role] || 0), 0);

export function canGrantRoles(callerRoles: string[], grantedRoles: string[]): boolean {
  if (callerRoles.includes('system_admin')) return true;
  if (!callerRoles.some((role) => GRANTER_ROLES.includes(role))) return false;
  return highestRank(grantedRoles) < highestRank(callerRoles);
}

/** Role labels the caller may give to someone else. */
export function grantableRoleLabels(callerRoles: string[]): string[] {
  return Object.keys(STAFF_ROLE_MAP).filter((label) => canGrantRoles(callerRoles, STAFF_ROLE_MAP[label]));
}

/** Whether the caller may edit someone currently holding `currentLabel`. */
export function canEditMemberRole(callerRoles: string[], currentLabel: string): boolean {
  return canGrantRoles(callerRoles, STAFF_ROLE_MAP[currentLabel] || []);
}
